import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/EmojiEvents';
import create from './create';
import edit from './edit';
import list from './list';

const awards: ResourceProps = {
  name: 'awards',
  icon,
  options: { label: 'Prêmios' },
  create,
  edit,
  list
};

export default awards;
